import CancelIcon from "@mui/icons-material/Cancel";
import SaveIcon from "@mui/icons-material/Save";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Tab,
} from "@mui/material";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import React from "react";
import { ThemeProvider } from "../v2/home/theme/ThemeProvider";

function TaskSchedulerMenu({
  open,
  onClose,
  loading,
  scheduleId,
  onSubmit,
  onCancel,
  detailsContent,
  scheduleContent,
}) {
  const [tabValue, setTabValue] = React.useState("1");

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      PaperProps={{
        sx: {
          width: 800,
          height: 600,
          maxWidth: "100%",
          maxHeight: "100%",
          borderRadius: 2,
        },
        component: "div",
      }}
    >
      <DialogTitle>
        {scheduleId !== 0 ? "Edit Schedule Task" : "Schedule Task"}
      </DialogTitle>

      <Divider />

      <Box
        component="form"
        onSubmit={onSubmit}
        noValidate
        autoComplete="off"
        sx={{ display: "flex", flexDirection: "column", flex: 1, minHeight: 0 }}
      >
        <DialogContent sx={{ pt: 2, overflow: "auto" }}>
          <ThemeProvider>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <TabContext value={tabValue}>
                <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                  <TabList onChange={handleTabChange} aria-label="Task schedule">
                    <Tab label="Details" value="1" />
                    <Tab label="Schedule" value="2" />
                  </TabList>
                </Box>
                <TabPanel value="1" sx={{ padding: "20px 0px" }}>
                  {detailsContent}
                </TabPanel>
                <TabPanel value="2" sx={{ padding: "20px 0px" }}>
                  {scheduleContent}
                </TabPanel>
              </TabContext>
            </LocalizationProvider>
          </ThemeProvider>
        </DialogContent>

        <Divider />

        <DialogActions sx={{ paddingRight: 1, marginBottom: "20px" }}>
          {/* <Button
            type="button"
            variant="outlined"
            onClick={onCancel}
            disabled={loading}
            startIcon={<CancelIcon />}
            sx={{
              float: "right",
              minWidth: 150,
              marginRight: "25px",
              marginTop: "10px",
              boxShadow: "0 3px 5px 2px rgba(25, 118, 210, .3)",
              "&:hover": {
                background: "invert(1)",
              },
            }}
          >
            Cancel
          </Button> */}
          <Button
            type="submit"
            disabled={loading}
            variant="contained"
            startIcon={
              loading ? <CircularProgress size={16} color="inherit" /> : <SaveIcon />
            }
            sx={{
              float: "right",
              minWidth: 150,
              marginRight: "25px",
              marginTop: "10px",
              background: "linear-gradient(45deg, #1976d2 30%, #42a5f5 90%)",
              boxShadow: "0 3px 5px 2px rgba(25, 118, 210, .3)",
              "&:hover": {
                background: "linear-gradient(45deg, #1565c0 30%, #1976d2 90%)",
              },
              border:0
            }}
          >
            {loading ? "Saving..." : scheduleId !== 0 ? "Update" : "Create"}
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
}

export default TaskSchedulerMenu;
